export const quotations = {
  alerts: {
    errorDuplicateEntryNumber: 'You’ve already used quotation number “{{entryNumber}}”.',
    missingFcFiles_one: 'The PDF for this quotation can’t be found.',
    missingFcFiles_other: 'The PDFs for these quotations can’t be found.',
    successCreated: 'Your quotation has been created.',
    successDeleted: 'Your draft has been deleted.',
    successUpdated: 'Your quotation has been updated.',
  },
  breadcrumb: {
    create: 'Quotation details',
    noTitle: 'No title',
    overview: 'Quotations',
  },
  clientAccept: {
    card: {
      button: 'Approve quotation',
      description: {
        accept: 'Do you agree with the quotation from {{user}}? Then approve it using the button below.',
        accepted: 'The quotation has been marked as approved.',
        declined: 'The quotation has been marked as rejected.',
        expired: 'The quotation has expired and can no longer be approved.',
      },
      title: 'Quotation from {{user}}',
    },
    preview: {
      assignment: {
        title: 'Assignment',
      },
      client: 'Client details',
      conditions: {
        description: 'Consult the terms and conditions of this quotation',
        title: 'Terms and conditions',
      },
      createdBy: 'This quotation was created and sent by',
      description: 'Description',
      expirationDate: 'Valid until',
      freelancer: 'Assignment carried out by',
      introduction: 'Introduction',
      specialConditions: 'Special conditions',
      title: 'Title',
    },
  },
  createEdit: {
    assignment: {
      description: 'Briefly describe what your assignment involves.',
      title: 'Assignment',
    },
    attachments: {
      description: 'Add any documents to this quotation.',
      error: {
        delete: 'Something went wrong while deleting the attachment.',
      },
      title: 'Email and attachments',
    },
    basicInfo: {
      description: 'All the basic information about your quotation.',
      title: 'Basic information',
    },
    blocker: {
      message: 'Are you sure you want to leave this page? Your changes to your quotation have not been saved.',
    },
    confirmation: {
      description: 'Are you sure you want to send the quotation? The quotation isn’t reviewed, it’s sent straight to your client.',
      submit: {
        create: 'Yes, send quotation',
        edit: 'Yes, send quotation',
      },
      title: 'Your quotation is being sent',
    },
    error: {
      title: 'Error loading your quotation.',
    },
    lines: {
      description: 'List the products and/or services you offer here.',
      title: 'Quotation lines',
    },
    preview: 'Preview',
    submit: {
      create: 'Send quotation',
      edit: 'Edit quotation',
      saveConcept: 'Save',
      saveSend: 'Save & send',
    },
    title: {
      create: 'Draft quotation',
      edit: 'Edit quotation',
    },
  },
  fields: {
    attachment: {
      label: 'Attachment',
    },
    description: {
      label: 'Description',
    },
    entryNumber: {
      label: 'Quotation number',
      last: 'Your last quotation has number <0>{{entryNumber}}</0>.',
      placeholder: 'Quotation number',
    },
    expirationDate: {
      label: 'Expiry date',
    },
    introduction: {
      label: 'Introduction',
    },
    mail: {
      default:
        '<p>\nHi #CLIENTNAME#,<br/><br/>\n\n#FREELANCERFIRSTNAME# has prepared a quotation for you. Could you take a look?<br/><br/>\n\nHere it is: #QUOTATIONLINK#.<br/><br/>\n\nAs soon as you give your approval, #FREELANCERFIRSTNAME# can get started.\n</p>',
      label: 'Email',
    },
  },
  header: {
    actionBlock: {
      button: 'Create quotation',
    },
    title: 'Quotations',
  },
  overview: {
    allowModal: {
      description: 'Are you sure you want to mark the quotation as approved?',
      title: 'Mark quotation as approved',
    },
    columns: {
      client: 'Client',
      date: 'Quotation date',
      days: 'days',
      entryNumber: 'Quotation',
      status: {
        options: {
          Approved: 'Approved',
          Draft: 'Draft',
          Expired: 'Expired',
          Rejected: 'Rejected',
          Sent: 'Sent',
        },
        title: 'Status',
      },
      total: 'Total (excl. VAT)',
    },
    declineModal: {
      description: 'Are you sure you want to mark the quotation as rejected?',
      title: 'Mark quotation as rejected',
    },
    error: {
      title: 'Error loading your quotations.',
    },
    rowActions: {
      allow: 'Approve',
      decline: 'Reject',
      download: 'Download',
      duplicate: 'Copy',
      invoice: 'Create invoice',
      preview: 'View',
    },
  },
  quotationForClient: {
    error: {
      title: 'Error loading the quotation.',
    },
  },
  richText: {
    shortcodes: {
      Clientname: 'Client name',
      Freelancerfirstname: 'Freelancer first name',
      Quotationlink: 'Quotation link',
    },
  },
};
